// components/FormInput.tsx
import React from "react";

interface FormInputProps {
  id: string;
  name: string;
  value: string;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormInput: React.FC<FormInputProps> = ({
  id,
  name,
  value,
  placeholder,
  onChange,
}) => {
  return (
    <div className="mb-5 w-full">
      <label
        htmlFor={id}
        className="block text-sm text-gray-400 mb-2"
      >
        {placeholder}
      </label>
      <input
        type="text"
        required
        id={id}
        name={name}
        placeholder={`EX: ${placeholder}`}
        value={value}
        onChange={onChange}
         className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-md px-3 py-2 text-white"
      />
    </div>
  );
};

export default FormInput;
